import { render, staticRenderFns } from "./RitualCircleArchive.vue?vue&type=template&id=2ab1fdec"
import script from "./RitualCircleArchive.vue?vue&type=script&lang=js"
export * from "./RitualCircleArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab1fdec')) {
      api.createRecord('2ab1fdec', component.options)
    } else {
      api.reload('2ab1fdec', component.options)
    }
    module.hot.accept("./RitualCircleArchive.vue?vue&type=template&id=2ab1fdec", function () {
      api.rerender('2ab1fdec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ritualCircles/RitualCircleArchive.vue"
export default component.exports